module.exports = __webpack_public_path__ + "img/app_dd.03a0dce5.png";